import { IComponentOptions, IController } from 'angular';
import { GmcTabController } from './components';

export class GmcTabSetController implements IController {
  tabs: GmcTabController[] = [];
  activeTab: GmcTabController;
  activeIndex: number;
  canActivate: boolean;
  disabled: boolean;
  onCheck: () => void;
  showWarn: (obj: any) => void;

  $onInit() {
  }

  $onChanges() {
    this.chooseTab();
  }

  $postLink() {
    this.chooseTab();
  }

  chooseTab() {
    if (this.canActivate) {
      const initedActiveTab = this.tabs[this.activeIndex];
      this.setActive(initedActiveTab);
    }
  }

  public addTab(tab: GmcTabController) {
    this.tabs = [...this.tabs, tab];
  }

  public async setActive(targetTab: GmcTabController, index?: number) {
    if (this.canActivate) {
      if (targetTab) {
        this.tabs.forEach((tab) => {
          if (targetTab === tab) {
            tab.isActive = true;
            this.activeTab = tab;
          } else {
            tab.isActive = false;
          }
        });
      }
      return;
    }
    this.showWarn({index: index});
  }

  public removeTab(tab: GmcTabController) {
    const index = this.tabs.indexOf(tab);
    if (this.activeTab === tab) {
      const newIndex = index === this.tabs.length - 1 ? index - 1 : index + 1 % this.tabs.length;
      this.setActive(this.tabs[newIndex]);
    }

    this.tabs = [
      ...this.tabs.slice(0, index),
      ...this.tabs.slice(index + 1)
    ];
  }
}

export const GmcTabsComponent: IComponentOptions = {
  controller: GmcTabSetController,
  transclude: true,
  template: require('./gmc-tab-set.component.html'),
  bindings: {
    activeIndex: '<',
    canActivate: '<?',
    disabled: '<?',
    onCheck: '&',
    showWarn: '&'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-tabs/gmc-tabs-set.component.ts